export const FLUTTER_MESSAGE = {
  LOGIN: 'login',
  UPDATE: 'update',
};
